import BaseEmberTooltip from 'ember-tooltips/components/ember-tooltip';

export default class EmberTooltip extends BaseEmberTooltip {
  // Setting defaults for ember-tooltips
  // Popper.js documentation: https://popper.js.org/docs/v1/
  popperContainer = 'body';

  popperOptions = {
    modifiers: {
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport',
        priority: ['left', 'right', 'bottom', 'top'],
        escapeWithReference: false,
      },
    },
  };
}
